import React from "react";
import { Col, Form } from "react-bootstrap";
import {
  handleContactChange,
  handleEMailChange,
  handleFirstNameChange,
  handleLastNameChange,
} from "../../Utils/userformhelpers";

export const LastNameForm = (elem) => {
  return (
    <>
      <Col sm="3">
        <Form.Label>Nachname:</Form.Label>
      </Col>
      <Col style={{ textAlign: "left", color: "#e95849" }}>
        <Form.Control
          type="text"
          placeholder=""
          defaultValue={elem.defaultvalue}
          onBlur={(event) => {
            const rsl = handleLastNameChange(event.target.value);
            let createLNDataCopy = elem.data;
            createLNDataCopy.items.ln = rsl[0];
            elem.changeState(createLNDataCopy, {
              errorMessageLastName: rsl[1],
            });
          }}
        />
        {elem.props.errorMessageLastName}
      </Col>
    </>
  );
};

export const FirstNameForm = (elem) => {
  return (
    <>
      <Col sm="3">
        <Form.Label>Vorname:</Form.Label>
      </Col>
      <Col style={{ textAlign: "left", color: "#e95849" }}>
        <Form.Control
          type="text"
          placeholder=""
          defaultValue={elem.defaultvalue}
          onBlur={(event) => {
            const rsl = handleFirstNameChange(event.target.value);
            let createFNDataCopy = elem.data;
            createFNDataCopy.items.fn = rsl[0];
            elem.changeState(createFNDataCopy, {
              errorMessageFirstName: rsl[1],
            });
          }}
        />
        {elem.props.errorMessageFirstName}
      </Col>
    </>
  );
};

export const EmailForm = (elem) => {
  return (
    <>
      <Col sm="3">
        <Form.Label>E-Mail:</Form.Label>
      </Col>
      <Col style={{ textAlign: "left", color: "#e95849" }}>
        <Form.Control
          type="email"
          placeholder=""
          defaultValue={elem.defaultvalue}
          onBlur={async (event) => {
            const rsl = await handleEMailChange(
              event.target.value,
              elem.current_em
            );
            let createEMDataCopy = elem.data;
            createEMDataCopy.items.em = rsl[0];
            if (elem.setupCompanyEmail === true) {
              //make company email same as admin-email
              createEMDataCopy.items["cm_em"] = rsl[0];
            }
            elem.changeState(createEMDataCopy, { errorMessageEMail: rsl[1] });
          }}
        />
        {elem.props.errorMessageEMail}
      </Col>
    </>
  );
};

export const ContactForm = (elem) => {
  return (
    <>
      <Col sm="3">
        <Form.Label>Handynr:</Form.Label>
      </Col>
      <Col style={{ textAlign: "left", color: "#e95849" }}>
        <Form.Control
          type="text"
          placeholder=""
          defaultValue={elem.defaultvalue}
          onBlur={async (event) => {
            const rsl = await handleContactChange(
              event.target.value,
              elem.initialContact
            );
            let createCODataCopy = elem.data;
            createCODataCopy.items.co = rsl[0];
            elem.changeState(createCODataCopy, {
              errorMessageContactNumber: rsl[1],
            });
          }}
        />
        {elem.props.errorMessageContactNumber}
      </Col>
    </>
  );
};
